import { mergeAttributes, Node } from '@tiptap/core'

export interface PdfAttrs {
  src: string
  s3Key?: string | null
  fileName?: string | null
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    pdf: {
      /** Insert an inline PDF embed node. */
      setPdf: (options: PdfAttrs) => ReturnType
    }
  }
}

/**
 * Inline PDF node rendered as an embedded viewer (iframe) with a download
 * fallback link. Persists the stable `s3Key` for re-signing on read.
 */
export const Pdf = Node.create({
  name: 'pdf',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      src: { default: null },
      s3Key: { default: null },
      fileName: { default: null },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-doc-pdf]' }]
  },

  renderHTML({ HTMLAttributes }) {
    const { src, fileName, s3Key } = HTMLAttributes
    return [
      'div',
      {
        'data-doc-pdf': 'true',
        'data-s3-key': s3Key ?? '',
        style: 'margin:12px 0;',
      },
      [
        'iframe',
        mergeAttributes(
          { src },
          {
            title: fileName || 'PDF document',
            style: 'width:100%;height:600px;border:1px solid #e0e0e0;border-radius:8px;',
          },
        ),
      ],
      [
        'a',
        { href: src, target: '_blank', rel: 'noopener noreferrer', style: 'font-size:13px;' },
        `Open ${fileName || 'PDF'} in new tab`,
      ],
    ]
  },

  addCommands() {
    return {
      setPdf:
        (options) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: options }),
    }
  },
})
